import { object, mixed } from "yup";
import { ExecutiveFields, PortalFields, PolicyValidations } from "./policy.types";

const REQUIRED_FIELD = "Ingrese este campo";
const INVALID_DATE = "El cliente es requerido";

export const policyExcelSchema = object().shape({
    cdCliente: mixed().required(REQUIRED_FIELD).typeError(INVALID_DATE),
});

export const initialPolicyValues = {
    idClient: "",
    poliza: "",
    tipoPol: "",
    fcDesde: "",
    fcHasta: "",
    cdEjecutivo: 0,
    file: null,
    polizaSelect: "",
    cdRamoCotizacion: 0,
    vigenciaSelect: [] as number[],
    validityDetails: [] as PolicyValidations[],
};

export const PolicyColumnLabels: Record<string, string> = {
    id: "ID",
    datePeriodFrom: "Periodo Desde",
    datePeriodTo: "Periodo Hasta",
    heading: "Titular",
    patient: "Paciente",
    patientIdentification: "Cédula",
    kinship: "Parentesco",
    gender: "Género",
    age: "Edad",
    incident: "Incidente",
    diagnosis: "Diagnóstico",
    owner: "Proveedor",
    networkType: "Tipo de Red",
    benefit: "Beneficio",
    typeCare: "Tipo de Atención",
    dateOccurrence: "Fecha Ocurrencia",
    dateFrom: "Fecha Desde",
    dateUntil: "Fecha Hasta",
    dateRegistration: "Fecha Registro",
    paymentDate: "Fecha Pago",
    presented: "Valor Presentado",
    deductible: "Deducible",
    coPayment: "Copago",
    paid: "Valor Pagado",
    uncovered: "No Cubierto",
    liquidation: "Liquidación",
    collectionNote: "Nota de Cobro",
    credit: "Crédito",
    plan: "Plan",
    subsidiary: "Cliente",
    cieCode: "Código CIE",
    severity: "Severidad",
    premiumBilled: "Prima Facturada",
    premiumsBilled: "Prima Facturada",
    consumptionDate: "Fecha Consumo",
};

export type HealthInformationRow = PortalFields | ExecutiveFields;
